import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.99788 3.74637C5.20204 3.74637 3.74622 5.20219 3.74622 6.99803V17.0022C3.74622 17.0633 3.7479 17.1241 3.75123 17.1844L7.0508 13.8848C8.125 12.8109 9.86635 12.8108 10.9406 13.8847L11.9985 14.9426L16.0575 10.8835C17.1317 9.80967 18.8731 9.80959 19.9473 10.8835L20.2537 11.1899V6.99803C20.2537 5.20219 18.7979 3.74637 17.002 3.74637H6.99788ZM21.7537 6.99803C21.7537 4.37376 19.6263 2.24637 17.002 2.24637H6.99788C4.37361 2.24637 2.24622 4.37376 2.24622 6.99803V17.0022C2.24622 19.6265 4.37361 21.7539 6.99788 21.7539H17.002C19.6263 21.7539 21.7537 19.6265 21.7537 17.0022V6.99803ZM20.2537 13.3112L18.8868 11.9443C18.3984 11.4561 17.6066 11.456 17.1182 11.9442L13.0591 16.0033L17.2966 20.2407C18.9544 20.0919 20.2537 18.6988 20.2537 17.0022V13.3112ZM15.1884 20.2539L9.88005 14.9455C9.39162 14.4573 8.59989 14.4573 8.11146 14.9455L4.27563 18.7813C4.85636 19.6681 5.85871 20.2539 6.99788 20.2539H15.1884ZM5.24747 7.49824C5.24747 6.25526 6.25511 5.24762 7.49809 5.24762C8.74108 5.24762 9.74872 6.25526 9.74872 7.49824C9.74872 8.74123 8.74108 9.74887 7.49809 9.74887C6.25511 9.74887 5.24747 8.74123 5.24747 7.49824ZM7.49809 6.74762C7.08353 6.74762 6.74747 7.08368 6.74747 7.49824C6.74747 7.9128 7.08353 8.24887 7.49809 8.24887C7.91265 8.24887 8.24872 7.9128 8.24872 7.49824C8.24872 7.08368 7.91265 6.74762 7.49809 6.74762Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.88005 14.9455L15.1884 20.2539H6.99788C5.85871 20.2539 4.85636 19.6681 4.27563 18.7813L8.11146 14.9455C8.59989 14.4573 9.39162 14.4573 9.88005 14.9455Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.8868 11.9443L20.2537 13.3112V17.0022C20.2537 18.6988 18.9544 20.0919 17.2966 20.2407L13.0591 16.0033L17.1182 11.9442C17.6066 11.456 18.3984 11.4561 18.8868 11.9443Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.74747 7.49824C6.74747 7.08368 7.08353 6.74762 7.49809 6.74762C7.91265 6.74762 8.24872 7.08368 8.24872 7.49824C8.24872 7.9128 7.91265 8.24887 7.49809 8.24887C7.08353 8.24887 6.74747 7.9128 6.74747 7.49824Z",
			fill: "#111827"
		})
	]
});
const ForwardRef = forwardRef(SvgImageFilled);
export default ForwardRef;
